/* Client-side proxy-URL format check, mirroring backend/utils/proxy.py.
 *
 * The OF gateway hands accounts.proxy_url straight to httpx, which needs a real
 * URL with a scheme + host + port. A schemeless "user:pass@host:port" (or a raw
 * "host:port:user:pass") 500s every proxied OF call, so we reject it before it
 * is ever sent. Backend validation is authoritative; this is for instant UX. */

export const ALLOWED_PROXY_SCHEMES = ['http', 'https', 'socks5', 'socks5h', 'socks4'];

export const PROXY_FORMAT_HINT =
  'scheme://[user:pass@]host:port (e.g. http://user:pass@1.2.3.4:8080)';

/** True when `raw` is a proxy URL the gateway can actually use. */
export function isValidProxyUrl(raw: string): boolean {
  const value = (raw || '').trim();
  if (!value) return false;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false; // no scheme, or otherwise unparseable
  }
  const scheme = url.protocol.replace(/:$/, '').toLowerCase();
  if (!ALLOWED_PROXY_SCHEMES.includes(scheme)) return false;
  if (!url.hostname) return false;
  if (!url.port) return false;
  return true;
}
